import request from '@/utils/request'
import { parseTime } from '@/utils'
import moment from "moment";

/**
 * 分页查询（约拍城市审核）
 * @param {*} query 参数
 */
export function getPagerByStore(query) {
  return getPager('/ShootCity/GetPagerByStore', query)
}

/**
 * 分页查询（约拍城市申请）
 * @param {*} query 参数
 */
export function getPagerByGrapher(query) {
  return getPager('/ShootCity/GetPagerByGrapher', query)
}

function getPager(url, query) {
  const response = request({
    url: url,
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取约拍城市统计信息
export function getAuditCityStatisticsByStore(query) {
  return request({
    url: '/ShootCity/GetAuditCityStatisticsByStore',
    method: 'get',
    params: query
  })
}

// 获取约拍城市统计信息
export function getAuditCityStatisticsByGrapher(query) {
  return request({
    url: '/ShootCity/GetAuditCityStatisticsByGrapher',
    method: 'get',
    params: query
  })
}

// 摄影师审核
export function auditShootCity(data) {
  return request({
    url: '/ShootCity/Audit',
    method: 'post',
    data
  })
}

// 新增约拍城市审核
export function addAuditShootCitys(data) {
  return request({
    url: '/ShootCity/AddAuditShootCitys',
    method: 'post',
    data
  })
}

/**
 * 获取中国所有城市
 * @param {*} params
 */
export function getCascaderData(params) {
  return request({
    url: '/SysArea/getCascaderData',
    method: 'get',
    params
  })
}

/**
 * 获取全球城市
 * @param {*} params
 */
export function getGlobalCities(params) {
  return request({
    url: '/SysArea/GetGlobalCities',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/m/shootCity.js